<app-base-modal
  [open]="open"
  (openChange)="openChange.emit($event)"
  (closed)="close()"
  title="Edit profile"
  size="md"
>
  <form class="space-y-4" [formGroup]="editForm" (ngSubmit)="save()">
    <div class="grid gap-4 sm:grid-cols-2">
      <div>
        <label for="profileFirstName" class="mb-1 block text-sm font-medium text-gray-700"
          >First name</label
        >
        <input
          id="profileFirstName"
          type="text"
          formControlName="firstName"
          class="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-secondary"
        />
        @if (submitted && editForm.controls.firstName.errors?.required) {
          <small class="text-sm text-red-600">First name is required.</small>
        }
      </div>

      <div>
        <label for="profileLastName" class="mb-1 block text-sm font-medium text-gray-700"
          >Last name</label
        >
        <input
          id="profileLastName"
          type="text"
          formControlName="lastName"
          class="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-secondary"
        />
        @if (submitted && editForm.controls.lastName.errors?.required) {
          <small class="text-sm text-red-600">Last name is required.</small>
        }
      </div>
    </div>

    <div>
      <label for="profileEmail" class="mb-1 block text-sm font-medium text-gray-700">Email</label>
      <input
        id="profileEmail"
        type="email"
        formControlName="email"
        class="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-secondary"
      />
      @if (submitted && editForm.controls.email.errors?.required) {
        <small class="text-sm text-red-600">Email is required.</small>
      }
      @if (submitted && editForm.controls.email.errors?.email) {
        <small class="text-sm text-red-600">Please enter a valid email address.</small>
      }
    </div>

    <div>
      <label for="profileAffiliation" class="mb-1 block text-sm font-medium text-gray-700"
        >Affiliation</label
      >
      <input
        id="profileAffiliation"
        type="text"
        formControlName="affiliation"
        class="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-secondary"
      />
      <p class="mt-1 text-xs text-gray-500">Optional university, company, or lab.</p>
    </div>

    <div>
      <label for="currentPassword" class="mb-1 block text-sm font-medium text-gray-700"
        >Current Password</label
      >
      <input
        id="currentPassword"
        type="password"
        formControlName="currentPassword"
        placeholder="Current password"
        class="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-secondary"
      />
      <p class="mt-1 text-xs text-gray-500">
        You need to provide your password in order to change profile data
      </p>
    </div>

    @if (submitted && editForm.controls.currentPassword.errors?.required) {
      <small class="text-sm text-red-600">Current password is required.</small>
    }

    @if (errorMessage) {
      <div class="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
        {{ errorMessage }}
      </div>
    }

    <div class="flex justify-end gap-2 pt-2">
      <button
        type="button"
        class="rounded-lg bg-slate-100 px-4 py-2 text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-200 disabled:cursor-not-allowed disabled:opacity-70"
        (click)="close()"
        [disabled]="saving"
      >
        Cancel
      </button>
      <button
        type="submit"
        class="rounded-lg bg-secondary px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-hover disabled:cursor-not-allowed disabled:opacity-70"
        [disabled]="saving"
      >
        {{ saving ? 'Saving...' : 'Save changes' }}
      </button>
    </div>
  </form>
</app-base-modal>
